import { i18n } from '@shared/i18n';
import { GenericModel } from '@shared/model/generic-model';
import StringField from '@shared/fields/string-field';
import IdField from '@shared/fields/id-field';
import IntegerField from '@shared/fields/integer-field';
import DateModelField from '@shared/fields/date-model-field';

function label(name) {
    return i18n(`entities.subprogram.nba.rounds.fields.${name}`);
}

const fields = ({ dateFormat }) => ({
    id: new IdField('id', label('id')),
    startDate: new DateModelField('startDate', label('startDate'), {
        format: 'MMM Do',
        "required": true,
        dateFormat,
    }),
    endDate: new DateModelField('endDate', label('endDate'), {
        format: 'MMM Do',
        "required": true,
        dateFormat,
    }),
    hostingSchoolDivisionIndex: new IntegerField('hostingSchoolDivisionIndex', label('hostingSchoolDivisionIndex'), { required: true }),
    gamesConfigurationString: new StringField('gamesConfigurationString', label('gamesConfigurationString'), { required: true }),
});

export class SubprogramRegularSeasonRoundsModel extends GenericModel {
    constructor({ dateFormat } = {}) {
        super();
        this.dateFormat = dateFormat;
    }

    fields() {
        const { dateFormat } = this;
        return fields({ dateFormat });
    }

    presenter(row, fieldName) {
        const fields = this.fields();

        if (!fields[fieldName]) {
            throw new Error(`${fieldName} not found`);
        }

        return fields[fieldName].forPresenter(
            row[fields[fieldName].name],
        );
    }
    // static get fields() {
    //     return fields;
    // }
}